import React, {useMemo} from 'react'
import {S3Client} from '@aws-sdk/client-s3'
import {Upload} from '@aws-sdk/lib-storage'
import {AssistantApi} from '../services/AssistantApi.service'
import {IResponsePresignedUrl} from '../types/preSigned'
import {captureError} from '../lib/sentry'

const s3 = new S3Client({
    region: 'sa-east-1',
})

/**
 * Faz upload de múltiplos arquivos para o Amazon S3.
 * @param files Os arquivos a serem enviados.
 * @param path O caminho (prefixo) onde os arquivos devem ser salvos no S3.
 * @returns Um array com os document_id dos uploads bem-sucedidos.
 */
export const uploadFilesToS3 = async (
    files: File[],
    path: string,
    organization_id: string,
    user_id: string,
    assistant_id: string
): Promise<string[]> => {
    const keyPrefix = path && !path.endsWith('/') ? `${path}/` : path || ''
    const api = new AssistantApi()

    const uploadPromises = files.map(async (file) => {
        try {
            const uploadData = await api.uploadS3PresignedUrl(
                path,
                user_id,
                organization_id,
                file,
                assistant_id
            )
            return uploadData
        } catch (error) {
            captureError(error, {
                context: 'uploadFilesToS3',
                fileName: file.name,
                path,
                organization_id,
                user_id,
                assistant_id,
            })
            return false
        }
    })

    try {
        const results = await Promise.all(uploadPromises)

        const documentIds = results
            .filter(
                (result): result is IResponsePresignedUrl =>
                    result !== false &&
                    typeof result === 'object' &&
                    'document_id' in result
            )
            .map((result) => result.document_id)

        return documentIds
    } catch (error) {
        captureError(error, {context: 'uploadFilesToS3.Promise.all', path})
        return []
    }
}
